import React, { useContext, useState } from 'react'
import Swal from 'sweetalert2'
import CadastroDashBoard from '../CadastroDashBoard';
import B2B_CotacaoVendas from '../../DashNativos/B2B_CotacaoVendas';
import B2B_NotaFiscal from '../../DashNativos/B2B_NotaFiscal';
import B2B_NotaFiscalServico from '../../DashNativos/B2B_NotaFiscalServico';
import B2B_TitulosPendentesVencidos from '../../DashNativos/B2B_TitulosPendentesVencidos';
import B2B_HistoricoTitulos from '../../DashNativos/B2B_HistoricoTitulos';
import B2B_PedidosPDV from '../../DashNativos/B2B_PedidosPDV';
import B2B_Maquinas from '../../DashNativos/B2B_Maquinas';
import B2B_MovimentacoesFiscais from '../../DashNativos/B2B_MovimentacoesFiscais';
import B2B_ContasPagarReceberEmAberto from '../../DashNativos/B2B_ContasPagarReceberEmAberto';
import B2B_Contratos from '../../DashNativos/B2B_Contratos';
import B2B_CotacaoContratos from '../../DashNativos/B2B_CotacaoContratos';
import B2B_FaturaContratos from '../../DashNativos/B2B_FaturaContratos';
import B2B_OrdemServico from '../../DashNativos/B2B_OrdemServico';
import Carrossel from '../../Carrossel/Carrossel';
import { useEffect } from 'react';
import CadastroImagens from '../CadastroImagens';
import { api } from '../../services/api';

import MyContext from '../../contexts/myContext';
import Departamentos from '../Departamentos';
import CadastroEmpresas from '../CadastroEmpresas';
import CadastroUsuarios from '../CadastroUsuarios';
import DashPorDepartamento from '../DashPorDepartamento';
import RenderLinkDash from '../RenderLinkDash';

import { CabecalhoAbas } from '../../components/CabecalhoAbas';
import RenderDescritivoDashHelp from '../RenderDescritivoDashHelp';

import styles from "./stylesHome.module.css"
import { SVGDashboard } from '../../public/SVG/SVGDashboard';

function Home() {

    const [dadosDash, setDadosDash] = useState([])

    const { tabsAbertas, user, tabAtual, Departamento, LinkDash, addTab, setDepartamento, setLinkDash } = useContext(MyContext)

    const getDadosDashBoard = async () => {
        await api
            .get('/dashboard/api/listaDashboard')
            .then(data => {
                setDadosDash(data.data)
            })
            .catch(error => console.log(error))
    }

    useEffect(() => {
        getDadosDashBoard()
    }, [tabAtual])

    useEffect(() => {
        if (tabAtual === 'OPÇÕES' || tabAtual === '') { /* OPÇÕES = HOME  */
            getDashboardsRecentes()
        }
    }, [tabAtual])

    const [listaDepartamentos, setListaDepartamentos] = useState([])
    const [ListaDashPermitidosUsuario, setListaDashPermitidosUsuario] = useState([])

    async function getListaDepartamentos() {
        await api
            .get(`/usuario/api/listaDepartamentosusuario/${user?.idUsuario}`)
            .then(data => {
                setListaDepartamentos(data.data)
            })
            .catch(error => console.log(`Erro em listaDepartamentosusuario. ${error}`))

        await api
            .get('/usuario/api/listaDashboardUsuario', { params: { IdUsuario: user?.idUsuario } })
            .then(data => {
                setListaDashPermitidosUsuario(data.data.filter(dash => dash.CheckDash === 1))
            })
            .catch(error => console.log(error))
    }

    useEffect(() => {
        if (user) {
            getListaDepartamentos()
        }
    }, [user])


    function renderCabecalhoAbas() {
        return (
            <CabecalhoAbas dadosDash={dadosDash} />
        )
    }

    function renderTabsTelasNativas() {
        return (<>
            {tabsAbertas.filter(aberta => aberta.name === 'renderlinkdash').length > 0 ?
                <div className={`${tabAtual === 'renderlinkdash' ? 'flex' : 'hidden'}`}>
                    <RenderLinkDash LinkDash={LinkDash} />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name.includes('AJUDA -')).map(tab => {
                return (
                    <div className={`${tabAtual === tab.name ? 'flex' : 'hidden'}`}>
                        <RenderDescritivoDashHelp dash={dadosDash.filter(d => d.NomeAmigavel.toUpperCase() === tab.name.toUpperCase().replace('AJUDA - ', ''))[0]} />
                    </div>
                )
            })}


            {tabsAbertas.filter(aberta => aberta.name === 'dashpordepartamento').length > 0 ?
                <div className={`${tabAtual === 'dashpordepartamento' ? 'flex h-full' : 'hidden'}`}>
                    <DashPorDepartamento Departamento={Departamento} />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'departamentos').length > 0 ?
                <div className={`${tabAtual === 'departamentos' ? 'flex' : 'hidden'}`}>
                    <Departamentos />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'cadastrodashboard').length > 0 ?
                <div className={`${tabAtual === 'cadastrodashboard' ? 'flex h-full' : 'hidden'}`}>
                    <CadastroDashBoard />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'cadastroimagens').length > 0 ?
                <div className={`${tabAtual === 'cadastroimagens' ? 'flex' : 'hidden'}`}>
                    <CadastroImagens />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'cadastroempresas').length > 0 ?
                <div className={`${tabAtual === 'cadastroempresas' ? 'flex' : 'hidden'}`}>
                    <CadastroEmpresas />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'cadastrousuarios').length > 0 ?
                <div className={`${tabAtual === 'cadastrousuarios' ? 'flex h-full' : 'hidden'}`}>
                    <CadastroUsuarios />
                </div>
                :
                null
            }
        </>)
    }

    function renderTabsDashboards() {
        return (<>
            {dadosDash.filter(aberta => aberta.Descricao === tabAtual && aberta.opTipoDash === 'CARROSSEL').length > 0 ?
                dadosDash.filter(tab => tab.Descricao === tabAtual && tab.opTipoDash === 'CARROSSEL').map(tab => {
                    return (
                        <div className={`${tab.Descricao === tabAtual ? 'flex h-full' : 'hidden'}`}>
                            <Carrossel
                                NomeAmigavel={tab.NomeAmigavel}
                                NomeInterno={tab.Descricao}
                            />
                        </div>
                    )
                })

                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_CotacaoVendas').length > 0 ?
                <div className={`${tabAtual === 'B2B_CotacaoVendas' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_CotacaoVendas
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_CotacaoVendas')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_NotaFiscal').length > 0 ?
                <div className={`${tabAtual === 'B2B_NotaFiscal' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_NotaFiscal
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_NotaFiscal')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_NotaFiscalServico').length > 0 ?
                <div className={`${tabAtual === 'B2B_NotaFiscalServico' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_NotaFiscalServico
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_NotaFiscalServico')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_TitulosPendentesVencidos').length > 0 ?
                <div className={`${tabAtual === 'B2B_TitulosPendentesVencidos' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_TitulosPendentesVencidos
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_TitulosPendentesVencidos')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_HistoricoTitulos').length > 0 ?
                <div className={`${tabAtual === 'B2B_HistoricoTitulos' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_HistoricoTitulos
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_HistoricoTitulos')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_PedidosPDV').length > 0 ?
                <div className={`${tabAtual === 'B2B_PedidosPDV' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_PedidosPDV
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_PedidosPDV')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_Maquinas').length > 0 ?
                <div className={`${tabAtual === 'B2B_Maquinas' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_Maquinas
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_Maquinas')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_MovimentacoesFiscais').length > 0 ?
                <div className={`${tabAtual === 'B2B_MovimentacoesFiscais' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_MovimentacoesFiscais
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_MovimentacoesFiscais')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_ContasPagarReceberEmAberto').length > 0 ?
                <div className={`${tabAtual === 'B2B_ContasPagarReceberEmAberto' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_ContasPagarReceberEmAberto
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_ContasPagarReceberEmAberto')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_Contratos').length > 0 ?
                <div className={`${tabAtual === 'B2B_Contratos' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_Contratos
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_Contratos')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_CotacaoContratos').length > 0 ?
                <div className={`${tabAtual === 'B2B_CotacaoContratos' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_CotacaoContratos
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_CotacaoContratos')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_FaturaContratos').length > 0 ?
                <div className={`${tabAtual === 'B2B_FaturaContratos' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_FaturaContratos
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_FaturaContratos')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }

            {tabsAbertas.filter(aberta => aberta.name === 'B2B_OrdemServico').length > 0 ?
                <div className={`${tabAtual === 'B2B_OrdemServico' ? 'flex h-full' : 'hidden'}`}>
                    <B2B_OrdemServico
                        NomeAmigavel={dadosDash.filter(d => d.Descricao === 'B2B_OrdemServico')[0].NomeAmigavel}
                    />
                </div>
                :
                null
            }
        </>)
    }

    const [listaDashRecentes, setListaDashRecentes] = useState([])

    async function getDashboardsRecentes() {
        const storedDashboardRecents = localStorage.getItem('dashboardRecents');

        let dashList = [];

        // Verifica se há dados no localStorage
        if (storedDashboardRecents) {
            // Se houver dados, converte para array e atribui a dashList
            dashList = JSON.parse(storedDashboardRecents);
        }

        setListaDashRecentes(dashList.filter(d => d.user.idUsuario == user.idUsuario && d.user.cnpj == user.cnpj))

    }

    async function handleVerDash(dash) {
        if (ListaDashPermitidosUsuario.filter(d => d.Descricao == dash.Descricao).length > 0) {
            if (dash.LinkDash) {
                addTab('renderlinkdash')
                setLinkDash(dash.LinkDash)
            }
            else {
                addTab(dash.Descricao)
            }
        }
        else {
            Swal.fire({
                icon: 'error',
                text: 'Dash não habilitado nas configurações de Usuário!',
                showConfirmButton: false,
                timer: 5000
            })
        }


    }

    function trataGuiasScroll_OK() {
        let vRetorno = false
        switch (tabAtual) {
            // case 'Carrossel':
            //     vRetorno = true
            //     break;
            case 'dashpordepartamento':
                vRetorno = true
                break;
            case 'Aircompany_OS':
                vRetorno = true
                break;
            case 'Aircompany_OS2':
                vRetorno = true
                break;
            case 'MetaDeVendasAirCompany':
                vRetorno = true
                break;
            case 'Aircompany_Oficina':
                vRetorno = true
                break;
            case 'Aircompany_Followup':
                vRetorno = true
                break;
            case 'cadastrousuarios':
                vRetorno = true
                break;

            case 'cadastrodashboard':
                vRetorno = true
                break;
            case 'Compolux_MetaGeral':
                vRetorno = true
                break;
            case 'Compolux_MetaVendedor':
                vRetorno = true
                break;
            case 'B2B_NotaFiscal':
                vRetorno = true
                break;
            case 'B2B_NotaFiscalServico':
                vRetorno = true
                break;
            case 'B2B_HistoricoTitulos':
                vRetorno = true
                break;
            case 'B2B_OrdemServico':
                vRetorno = true
                break;
            case 'B2B_PedidosPDV':
                vRetorno = true
                break;
            case 'B2B_TitulosPendentesVencidos':
                vRetorno = true
                break;
            case 'B2B_Contratos':
                vRetorno = true
                break;
            case 'Confiance_GestaoAlmoxarifado':
                vRetorno = true
                break;
            case 'Confiance_GestaoCompras':
                vRetorno = true
                break;
            case 'B2B_CotacaoContratos':
                vRetorno = true
                break;
            case 'B2B_FaturaContratos':
                vRetorno = true
                break;
            case 'B2B_Maquinas':
                vRetorno = true
                break;
            case 'B2B_MovimentacoesFiscais':
                vRetorno = true
                break;
            case 'B2B_ContasPagarReceberEmAberto':
                vRetorno = true
                break;
            case 'B2B_CotacaoVendas':
                vRetorno = true
                break;
            case 'Empicamp_Comercial':
                vRetorno = true
                break;
            case 'Empicamp_CotacaoDesempenho':
                vRetorno = true
                break;
            case 'Empicamp_AcompanhamentoServicos':
                vRetorno = true
                break;
            case 'Empicamp_GerencialOP':
                vRetorno = true
                break;
            case 'Empicamp_GerencialOPAnalitico':
                vRetorno = true
                break;
            case 'Airservice_Sala1':
                vRetorno = true
                break;
            case 'Airservice_Sala2':
                vRetorno = true
                break;
            case 'DisponibilidadeMaquinasEquipamentos':
                vRetorno = true
                break;
            case 'Jva_GestaoOrcamentos':
                vRetorno = true
                break;
            case 'Jva_AnaliseMargemOrcamentos':
                vRetorno = true
                break;
            case 'Jva_OrcamentoSubStatus':
                vRetorno = true
                break;
            case 'Jva_ReposicaoEstoque':
                vRetorno = true
                break;
            case 'Aircompany_OrdemServicoSubStatus':
                vRetorno = true
                break;
            case 'Confiance_OrdemServicoSubStatus':
                vRetorno = true
                break;
            case 'Jva_DemandaSetorCompras':
                vRetorno = true
                break;
            default:
                break;
        }
        return vRetorno
    }


    return (
        <div className="home max-h-screen overflow-hidden bg-transparent">
            {renderCabecalhoAbas()}

            <div className={`${trataGuiasScroll_OK() === true ? 'w-full h-full' : 'max-h-[93.5vh] overflow-scroll'} ${tabsAbertas.length === 1 ? 'hidden' : 'flex'}`}>
                <div className={`${trataGuiasScroll_OK() === true ? 'w-full' : 'h-full w-full overflow-scroll div-scroll-hidden'} `} >
                    {renderTabsTelasNativas()}
                    {renderTabsDashboards()}
                </div>
            </div>
            <div className={`h-[93%] ${tabAtual === 'OPÇÕES' || tabAtual === '' ? 'flex' : 'hidden'}`} >
                {/* 
                    <IframeDashURL URL="https://inntegra.com.br/" />
                */}
                <div className={`${styles.divHome}`}>
                    <div className='flex flex-row gap-2 items-center' >
                        <p className={` text-white-100 ${styles.textOla} `}>Olá, </p>
                        <p className={` text-white-100 ${styles.userName} `}>{user.Nome}</p>
                    </div>

                    <div className={`${styles.divTitle}`}>

                        <p className={` text-white-100 whitespace-nowrap ${styles.title} `}>Bem vindo ao Mais Prático</p>
                        <p className={` text-gray-200 ${styles.subTitle} `}>B2B</p>
                    </div>

                    <div className={`${styles.divMain}`}>
                        <div className={`${styles.divDashRecentes}`} >
                            <div className='flex flex-row gap-3 items-center '>
                                <div className='text-2xl'>
                                    <SVGDashboard color={'white'} />
                                </div>
                                <p className={` text-white-100 whitespace-nowrap ${styles.titleDepartamento} `}>Dashs Recentes</p>
                            </div>
                            <p className={` text-white-100 ${styles.textInfo} `}>Dashs usados neste Navegador pelo seu usuário</p>
                            <div className={`${styles.divScrollItens}`}>
                                {
                                    listaDashRecentes.sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp)).map(dash => {
                                        return (
                                            <p onClick={() => {
                                                handleVerDash(dash)
                                            }} className={` text-white-100 ${styles.nomeDepartamento} `}>{dash.NomeAmigavel.toUpperCase()}</p>
                                        )
                                    })
                                }
                            </div>
                        </div>

                        <div className={`${styles.divDepartamentos}`} >
                            <p className={` text-white-100 whitespace-nowrap ${styles.titleDepartamento} `}>Seus Departamentos</p>
                            <p className={` text-white-100 ${styles.textInfo} `}>Departamentos liberados para seu usuário</p>
                            <div className={`${styles.divScrollItens}`}>
                                {listaDepartamentos.map(dep => {
                                    return (
                                        <p onClick={() => {
                                            addTab('dashpordepartamento')
                                            setDepartamento(dep.Departamento)
                                        }} className={` text-white-100 ${styles.nomeDepartamento} `}>{dep.Departamento}</p>
                                    )
                                })}
                            </div>

                        </div>


                    </div>
                </div>

                <a className='absolute text-end right-6 mb-2 underline text-white-200 w-full bottom-0' href={`https://inntegra.com.br/`} rel="noreferrer" target="_blank">https://inntegra.com.br</a>
            </div>
        </div>
    )
}

export default Home
